module.exports = __webpack_public_path__ + "img/p1-info.414b9413.jpg";